// =============================================================================
// Back-office: horas extra del equipo
// =============================================================================
import { apiClient } from './http';

export interface TeamOvertimeRow {
  user_id: number;
  name: string;
  accrued_hours: number;
  cap_hours: number;
  percent: number;
  at_cap: boolean;
  forbidden: boolean;   // tiempo parcial: prohibidas (art. 12.4.c)
}

export async function getTeamOvertime(year: number): Promise<TeamOvertimeRow[]> {
  const res = await apiClient.get<TeamOvertimeRow[]>(`/overtime/team/${year}`);
  return res.data;
}
